// @ts-nocheck
import {StyledTitle} from './StyledTitle';

const Title = (props) => {
  return  <StyledTitle {...props} />;
};
export default Title;